import { Modal, Button, Row, Col, Card } from 'antd';
import { VIEWS } from '../../../utils/emailUtils';
import moment from 'moment';
import { ssDateUtils } from '@bit/ui-common.ui-components/ss-utils';

const { unixSecondsToTimestampString } = ssDateUtils;

const
{ DEFAULT } = VIEWS,
preWrapConfig = {
    maxHeight: '350px',
    scroll: 'auto',
    whiteSpace: 'pre-wrap',
    whiteSpace: 'moz-pre-wrap',
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word'
},
preHeadWrapConfig = {
    maxHeight: '200px',
    scroll: 'auto',
    whiteSpace: 'pre-line',
    wordWrap: 'break-word'
}

export default class EmailInfo extends React.Component {
    state = { visible: true }
    constructor(props) {
        super(props);
        this.changeView = this.props.controls.changeView.bind(this);
    }

    hideModal = () => this.changeView(DEFAULT);

    sanitizeString = (string) => {
        return string.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&#034;').replace(/'/g, '&#039;');
    }

    printEmail = (emailInfo) => {
        var printWindow = window.open('', 'Email' + emailInfo.emailId, 'height=600,width=800');
        if (emailInfo.emailType === 'DAFP' || emailInfo.emailType === 'DAF' || emailInfo.emailType === 'DAFFR' || emailInfo.emailType === 'DAFNFR') {
            printWindow.document.write('<html><head><title>Email</title></head>');
        }else{
            printWindow.document.write('<html><head><title>Email ' + emailInfo.emailId + '</title></head>');
        }
        printWindow.document.write('<body style="font-family: SFMono-Regular, Consolas, Liberation Mono, Menlo, Courier, monospace;">');

        printWindow.document.write('<div id="print-email-header">');
        if (emailInfo.emailType !== 'DAF' && emailInfo.emailType !== 'DAFP' && emailInfo.emailType !== 'DAFFR' & emailInfo.emailType !== 'DAFNFR') {
            printWindow.document.write('<b>Email ID: </b>' + emailInfo.emailId + '<br/><br/>');
        }

        printWindow.document.write('<b>Recipient: </b><span>' + this.sanitizeString(emailInfo.recipients) + '</span><br/><br/>');
        printWindow.document.write('<b>Subject: </b>' + this.sanitizeString(emailInfo.subject) + '<br/><br/>');
        printWindow.document.write('<b>Date Sent: </b>' + unixSecondsToTimestampString(emailInfo.dateSent) + '<br/><br/>');
        printWindow.document.write('</div>');

        printWindow.document.write('<hr/><br/>');

        printWindow.document.write('<div id="print-email-content" style="white-space: pre-wrap; overflow-wrap: break-word;">')
        printWindow.document.write(this.sanitizeString(emailInfo.content));
        printWindow.document.write('</div>');

        printWindow.document.write('</body>');
        printWindow.document.write('</html>');

        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();

        return true;
    }

    getHeaderElement = (name, value) => (
        <Row>
            <Col span={5} style={{textAlign:'right'}}>
                <h4>{name + ": "}</h4>
            </Col>
            <Col span={1} />
            <Col span={18}>
                <p>{value}</p>
            </Col>
        </Row>
    );

    getEmailHeader(email) {
        if (email) return (
            <Col>
              <pre id="email-header" style={{ ...preHeadWrapConfig }}>
                {!email.emailId || email.emailType === 'DAFP' || email.emailType === 'DAF' ||  email.emailType === 'DAFFR' || email.emailType === 'DAFNFR' ? null : this.getHeaderElement("Email ID", email.emailId)}
                {!email.trId ? null : this.getHeaderElement("Training Request ID", email.trId)}
                {!email.studentName ? null : this.getHeaderElement("Student Name", email.studentName)}
                {!email.recipients ? null : this.getHeaderElement("Recipients", email.recipients)}
                {!email.subject ? null : this.getHeaderElement("Subject", email.subject)}
                {!email.cc ? null : this.getHeaderElement("cc", email.cc)}
                {!email.dateSent ? null : this.getHeaderElement("Date Sent", unixSecondsToTimestampString(email.dateSent))}
                </pre>
            </Col>
        );
    }

    render() {
        const
        { hideModal, printEmail, state, props } = this,
        { emailInfo, services } = props;
        return (
            <div>
                <Row type='flex' justify='center' align='middle'>
                    <Col span={24}>
                        <Modal
                            visible={state.visible}
                            footer={
                                <div>
                                    <Button onClick={() => printEmail(emailInfo)}>
                                        {'Print'}
                                    </Button>
                                    <Button onClick={() => {
                                        hideModal();
                                        services.clearEmail();
                                    }}>
                                        {'Close'}
                                    </Button>
                                </div>
                            }
                            closable={false}
                        >
                            <Card title={ this.getEmailHeader(emailInfo)}>
                                <div style={{ overflow: 'auto' }}>
                                    <pre id="email-content" style={{...preWrapConfig}}>
                                        {emailInfo && emailInfo.content}
                                    </pre>
                                </div>
                            </Card>
                        </Modal>
                    </Col>
                </Row>
            </div>
        );
    }
}
